<template>

    <v-step :step="step" title="Actions">
        <div class="p-20">
            <transition name="modal">
                <v-modal-action-create v-if="showModal === 'add'" />
            </transition>
            <v-notice v-if="!actions.length" message="Add one or more actions." />
            <div class="actions">
                <v-action v-for="action in actions" :key="action.id" :action="action" />
            </div>
        </div>
        <template #footer>
            <v-button size="sm" @click.native="$store.commit('showModal', 'add')">Add Action</v-button>
        </template>
    </v-step>

</template>

<style scoped lang="scss">

    .actions {
        display: grid;
        gap: 5px;
    }

</style>

<script>

import ModalActionCreate from '@modals/action/ModalActionCreate';
import Step from '@pages/automations-edit/components/Step';
import StepActionsAction from '@pages/automations-edit/components/StepActionsAction';

export default {

    components: {
        'v-action': StepActionsAction,
        'v-modal-action-create': ModalActionCreate,
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    data() {
        return {
            actions: [],
        }
    },

    mounted() {
        this.actions = this.campaign.actions;
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

    },

    watch: {

        campaign: {
            deep: true,
            handler(val) {
                this.actions = val.actions;
            }
        },

    },

}

</script>
